import { makeStyles } from '@mui/styles'

export const useStyles = makeStyles((theme) => ({
    defaultStyle: {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        height: '15vh',
        border: `dashed 2px ${theme.palette.grey[300]}`,
        padding: '3%',
        borderRadius: 5,
        cursor: 'pointer',
        flexGrow: 0,
        marginTop: '6%',
        marginBottom: '2%',
        width: '85%'
    },
    disabledStyle: {
        border: `dashed 2px ${theme.palette.grey[600]}`,
        cursor: 'no-drop'
    },
    input: {
        display: 'block',
        opacity: 0,
        position: 'absolute',
        pointerEvents: 'none',
        width: '100%',
        height: '100%'
    },
    uploaderWrapper: {
        position: 'relative',
        '&:focus-within': {
            outline: `2px solid ${theme.palette.common.black}`
        }
    },
    hoverMsg: {
        border: `dashed 2px ${theme.palette.grey[600]}`,
        borderRadius: 5,
        backgroundColor: theme.palette.grey[300],
        opacity: 0.5,
        position: 'absolute',
        top: 0,
        right: 0,
        left: 0,
        bottom: 0,
        '& > span': {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translateX(-50%) translateY(-50%)'
        },
        alignSelf: 'center',
        width: '100%',
        height: '100%'
    },
    descriptionWrapper: {
        display: 'flex',
        justifyContent: 'space-between',
        flexGrow: 1,
        margin: 20,
        alignItems: 'center',
        '& > span': {
            fontSize: '1em',
            color: (props: { error?: boolean }) =>
                props.error ? 'red' : `${theme.palette.grey[600]} !important`
        }
    },
    fileTypes: {
        color: `${theme.palette.grey[600]} !important`,
        fontSize: '1em',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        maxWidth: 100
    }
}))

export default useStyles
